<template>
  <div class="td-tool">
    <div class="td-toolbar">
      <span class="td-label">{{ $t('tool.TextDedup.title') }}</span>
      <span class="td-spacer"/>
      <el-button size="small" @click="dedup">{{ $t('tool.TextDedup.btnDedup') }}</el-button>
      <el-button size="small" @click="sortAsc">{{ $t('tool.TextDedup.btnSortAsc') }}</el-button>
      <el-button size="small" @click="sortDesc">{{ $t('tool.TextDedup.btnSortDesc') }}</el-button>
      <el-button size="small" @click="reverse">{{ $t('tool.TextDedup.btnReverse') }}</el-button>
      <el-button size="small" @click="trim">{{ $t('tool.TextDedup.btnTrim') }}</el-button>
      <el-button size="small" type="primary" icon="el-icon-document-copy" @click="doCopy">{{ $t("common.action.copy") }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <el-input v-model="text" type="textarea" :rows="18" :placeholder="$t('tool.TextDedup.phInput')"
      class="td-textarea" @input="onInput"/>
    <div class="td-status-bar">
      <span v-if="lastOp" class="td-ok">
        <i class="el-icon-circle-check"/> {{ lastMsg }}
      </span>
      <span v-else-if="text.trim()" class="td-hint">{{ $t('tool.TextDedup.hintLines', { lines: lines.length, chars: chars }) }}</span>
      <span v-else class="td-hint">{{ $t('tool.TextDedup.hintEmpty') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'TextDedupTool',props:{config:{type:Object,default:()=>({})}},
  data:function(){
    return { text:'', lastOp:'', lastMsg:'' }
  },
  computed:{
    lines:function(){ return this.text.split('\n') },
    chars:function(){ return this.text.length }
  },
  methods:{
    onInput:function(){ this.lastOp = ''; this.lastMsg = '' },
    getLines:function(){ return this.text.split('\n') },
    setLines:function(arr,op,msg){
      this.text = arr.join('\n')
      this.lastOp = op; this.lastMsg = msg
    },
    dedup:function(){
      var lines = this.getLines(); var before = lines.length
      var result = [...new Set(lines)]
      this.setLines(result, 'dedup', this.$t('tool.TextDedup.msgDedup', { before: before, after: result.length, removed: before - result.length }))
    },
    sortAsc:function(){
      var lines = this.getLines(); var before = lines.length
      var result = [...lines].sort(function(a,b){ return a.localeCompare(b) })
      this.setLines(result, 'sortAsc', this.$t('tool.TextDedup.msgSortAsc', { n: before }))
    },
    sortDesc:function(){
      var lines = this.getLines(); var before = lines.length
      var result = [...lines].sort(function(a,b){ return b.localeCompare(a) })
      this.setLines(result, 'sortDesc', this.$t('tool.TextDedup.msgSortDesc', { n: before }))
    },
    reverse:function(){
      var lines = this.getLines()
      this.setLines([...lines].reverse(), 'reverse', this.$t('tool.TextDedup.msgReverse', { n: lines.length }))
    },
    trim:function(){
      var lines = this.getLines(); var before = lines.length
      var result = lines.filter(function(l){ return l.trim() })
      this.setLines(result, 'trim', this.$t('tool.TextDedup.msgTrim', { before: before, after: result.length, removed: before - result.length }))
    },
    doCopy:function(){
      if (!this.text.trim()) { this.$message.warning(this.$t("common.status.noContent")); return }
      navigator.clipboard.writeText(this.text).then(this.$message.success(this.$t("common.status.copied")))
    },
    clearAll:function(){ this.text = ''; this.lastOp = ''; this.lastMsg = '' },
    doAction:function(a){
      if (a === 'copy') this.doCopy()
      if (a === 'clear') this.clearAll()
    }
  }
}
</script>

<style scoped>
.td-tool{display:flex;flex-direction:column;gap:12px}

.td-toolbar{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.td-toolbar >>> .el-button + .el-button{margin-left:0}
.td-label{font-size:13px;font-weight:700;color:#1a1f36;white-space:nowrap}
.td-spacer{flex:1}

.td-textarea >>> textarea{
  font-family:'JetBrains Mono','Fira Code','Consolas',monospace!important;
  font-size:13px!important;line-height:1.6!important;
  border-radius:10px;resize:vertical;min-height:360px
}

.td-status-bar{font-size:12px}
.td-ok{color:#67c23a;display:flex;align-items:center;gap:4px}
.td-hint{color:#c0c4cc}
</style>
